import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ServiceCallEquipmentSummaryService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  getSummary(id) {
    const url = this.urlPrefix + 'service-calls/' + id + '/equipment-summary';
    return this.http
      .get(url, {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-detail/service-call-equipment-summary.service.ts